export default "__VITE_ASSET__38f34b26__"